import React, { useState } from 'react';
import {
    Heading,
    DesktopSearch,
    SubHeading,
    MobileSearch,
    StyledSortIcon,
} from './InventorySearch.styled';
import HighlightSearch from './HighlightSearch';
import Select from 'src/common/refactoredComponents/select/Select';
import SortGeneral from 'src/assets/images/SortGeneral.svg';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
    getInventoryDetails,
    setInventoryItemsDetails,
} from '../../redux/actions';

const InventorySearch = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const options = [
        {
            value: 'cfn_ASC',
            label: t('consignmentReturn.inventory.itemAscending'),
            className: 'customFontDropDown',
        },
        {
            value: 'cfn_DESC',
            label: t('consignmentReturn.inventory.itemDescending'),
            className: 'customFontDropDown',
        },
        {
            value: 'useByDate_ASC',
            label: t('consignmentReturn.inventory.useByDateAscending1'),
            className: 'customFontDropDown',
        },
        {
            value: 'useByDate_DESC',
            label: t('consignmentReturn.inventory.useByDateDescending'),
            className: 'customFontDropDown',
        },
        {
            value: 'batch_ASC',
            label: t('consignmentReturn.inventory.lotSerialNumberAscending'),
            className: 'customFontDropDown',
        },
        {
            value: 'batch_DESC',
            label: t('consignmentReturn.inventory.lotSerialNumberDescending'),
            className: 'customFontDropDown',
        },
        {
            value: 'onhand_ASC',
            label: t('consignmentReturn.inventory.quantityOnHandAscending'),
            className: 'customFontDropDown',
        },
        {
            value: 'onhand_DESC',
            label: t('consignmentReturn.inventory.quantityOnHandDescending'),
            className: 'customFontDropDown',
        },
    ];
    const [selectedOption, setselectedOption] = useState(
        t('consignmentReturn.inventory.useByDateAscending1')
    );
    const {
        accountId,
        patientFirstName,
        patientLastName,
        physicianName,
        hrefId,
    } = useSelector((state) => ({
        accountId: state.consignmentReturnReducer.surgeryDetails.accountId,
        patientFirstName:
            state.consignmentReturnReducer.surgeryDetails.patientFirstName,
        patientLastName:
            state.consignmentReturnReducer.surgeryDetails.patientLastName,
        physicianName:
            state.consignmentReturnReducer.surgeryDetails.physicianId,
        hrefId: state.consignmentReturnReducer.surgeryDetails.hrefId,
    }));
    const checkedItems = useSelector(
        (state) => state.InventoryReturnReducer.checkedItems
    );
    const handleFilterChange = (selectedOption) => {
        let sortParams = selectedOption.split('_', 2);
        const payload = {
            accountNumber: accountId.accountId,
            productType: 'tissue',
            orderType: 'ZKA',
            resourceType: 'INVENTORY_LIST',
            sortCode: sortParams[0],
            sortOrder: sortParams[1],
            currentPage: '0',
            filterParam: 'all',
            searchQuery: props.searchItem,
            pageSize: '50',
        };
        dispatch(getInventoryDetails(payload));
        setselectedOption(selectedOption);
    };

    const clearSelectedClickHandler = () => {
        const selectedItemIds = props.checked
            .filter((x) => x.isChecked)
            .map((y) => y.cfn);
        const modifiedGridData = props.checked.map((obj) => ({
            ...obj,
            itemDetails: selectedItemIds.includes(obj.cfn)
                ? null
                : obj.itemDetails,
            isChecked: false,
        }));
        dispatch(setInventoryItemsDetails([]));
        props.setChecked(modifiedGridData);
        props.setModifiedData([]);
        props.setFilterCheckedItems([]);
        props.setItemCheckedCount(0);
        props.setClearAll(true);
    };
    return (
        <>
            <DesktopSearch>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                        <SubHeading isDemi>
                            {t(
                                'consignmentReturn.inventory.searchWithinInventory'
                            )}
                        </SubHeading>
                    </div>
                    <div style={{ margin: 'auto' }}>
                        <HighlightSearch
                            setSearchItem={props.setSearchItem}
                            setShowBtn={props.setShowBtn}
                        />
                    </div>
                </div>

                <Button
                    id={'pages-consignmentReturn-inventorySearch-inventory-search'}
                    show
                    // secondary
                    variant={(checkedItems && checkedItems.length > 0) ? ButtonStyles?.clearSelectedEnabled : ButtonStyles?.clearSelectedDisabled}
                    width={'90px'}
                    height={'33px'}
                    clicked={clearSelectedClickHandler}
                    margin={'5px'}
                    mobileMargin={'5px 0px 5px 5px'}
                    WhiteSpace={'nowrap'}
                    fontSize={'13px'}
                   // border={'1px solid #EBEBEB'}
                    borderRadius={'6px'}
                    // color={
                    //     checkedItems && checkedItems.length > 0
                    //         ? '#1010EB'
                    //         : '#B2B2B2'
                    // }
                    disabled={
                        checkedItems && checkedItems.length > 0 ? false : true
                    }
                >
                    {t('consignmentReturn.inventory.clearAll')}
                </Button>
            </DesktopSearch>
            <MobileSearch>
                <div id="consignmentReturn-inventorySearch-pii" style={{ display: 'block' }}>
                    <div>
                        <Heading isDemi>
                            {accountId?.accountName}{' '}
                            <Heading isItalic>
                                {accountNumberZeroTrimmer(
                                    accountId?.accountId || ''
                                )}{' '}
                            </Heading>
                        </Heading>
                    </div>

                    <div>
                        <Heading isDemi>
                            {physicianName
                                ? `${t('common.drLabel')} ${physicianName}`
                                : ''}
                            {patientFirstName && (
                                <Heading isRegular>
                                    {' '}
                                    |{t(
                                        'consignmentReturn.inventory.patient'
                                    )}{' '}
                                    {patientFirstName + ' ' + patientLastName}{' '}
                                </Heading>
                            )}
                        </Heading>
                        <div>
                            {hrefId && (
                                <Heading isRegular>
                                    {t('consignmentBilling.inventory.href')}{' '}
                                    {hrefId}{' '}
                                </Heading>
                            )}
                        </div>
                    </div>
                </div>
                <SubHeading isDemi>
                    {t('consignmentReturn.inventory.searchWithinInventory')}
                </SubHeading>
                <HighlightSearch
                    setSearchItem={props.setSearchItem}
                    setShowBtn={props.setShowBtn}
                />
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'inherit',
                        marginTop: '18px',
                    }}
                >
                    <StyledSortIcon>
                        <img src={SortGeneral} />
                    </StyledSortIcon>
                    <div>
                        <Select
                            id="consignmentReturn-inventorySearch-inventory-search"
                            height={'40px'}
                            width={'224px'}
                            placeholder={t(
                                'consignmentReturn.inventory.useByDateAscending'
                            )}
                            options={options}
                            value={selectedOption}
                            onChange={handleFilterChange}
                            scrollHeight={'365px'}
                            selectedLabelFontSize={'14px'}
                            labelColor={'#202124'}
                            hideClear={true}
                        />
                    </div>
                    {/* <SortContainer>Item # (Asending)</SortContainer> */}
                    <div>
                        <Button
                            id={'pages-consignmentReturn-inventorySearch-clearAll'}
                            show
                            // secondary
                            variant={ButtonStyles?.secondary}
                            mobileWidth={'73px'}
                            height={'33px'}
                            clicked={clearSelectedClickHandler}
                            margin={'5px'}
                            mobileMargin={'5px 0px 5px 5px'}
                            WhiteSpace={'nowrap'}
                            fontSize={'13px'}
                            border={'1px solid #EBEBEB'}
                            borderRadius={'6px'}
                            color={
                                props.filterCheckedItems &&
                                    props.filterCheckedItems.length > 0
                                    ? '#1010EB'
                                    : '#B2B2B2'
                            }
                            disabled={
                                props.filterCheckedItems &&
                                    props.filterCheckedItems.length > 0
                                    ? false
                                    : true
                            }
                        >
                            {t('consignmentReturn.inventory.clearAll')}
                        </Button>
                    </div>
                </div>
            </MobileSearch>
        </>
    );
};

export default InventorySearch;
